import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, FormGroupProps, Row } from 'react-bootstrap';

import { FormGroupControl } from '@components/Base';

type Props = {
  premiumName: string;
  discountName?: string;
  title: string;
  disabled?: boolean;
  groupProps?: FormGroupProps;
};

const AmountControl = ({ premiumName, discountName, title, disabled, groupProps }: Props) => {
  const { t } = useTranslation();

  return (
    <fieldset className="mb-4 pb-2 border-bottom">
      <legend className="h6">{title}</legend>

      <Row>
        <Col>
          <FormGroupControl
            name={premiumName}
            label={t('common:premium')}
            required
            groupProps={groupProps}
            type="number"
            disabled={disabled}
          />
        </Col>
        {discountName && (
          <Col>
            <FormGroupControl
              name={discountName}
              label={t('common:discount')}
              required
              groupProps={groupProps}
              type="number"
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
    </fieldset>
  );
};

export { AmountControl };
